module.exports = __webpack_public_path__ + "375a03714d2c69a825c9baeb9f17b9f1.svg";